module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/candidate/admissionfeespaymentconfirm/admissionfeespaymentconfirm.component.scss
// module id = ./src/app/candidate/admissionfeespaymentconfirm/admissionfeespaymentconfirm.component.scss
// module chunks = main